import {memo} from 'react'

import {LoadingBasic} from '@defign/ui'
import classNames from 'classnames/bind'

import Styles from './LoadingBar.module.scss'

import type {CSSProperties} from 'react'

const cx = classNames.bind(Styles)

interface LoadingBarProps {
    size?: 'size5' | 'size6'
    style?: CSSProperties
}

// 사용되는 컴포넌트에 wrapper 로 영역을 잡아서 사용
const LoadingBar = ({style, size}: LoadingBarProps) => {
    return (
        <span className={cx('article', size)} style={style}>
            {size === 'size5' ? (
                <LoadingBasic width={19} height={5} />
            ) : size === 'size6' ? (
                <LoadingBasic width={23} height={6} />
            ) : (
                <LoadingBasic width={38} height={10} />
            )}
        </span>
    )
}

export default memo(LoadingBar)
